export function teamSlider() {
    const slider = $(".team-slider .slider");
    slider.slick({
        infinite: true,
        arrows: false,
        dots: true,
        autoplay: true,
        autoplaySpeed: 5000,
        fade: true,
        fadeSpeed: 1000,
    });

    $(".slick-dots button").each((i, it) => {
        $(it).on("mouseenter", () => {
            slider.slick("slickGoTo", i);
        });
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/team-slider.js